import React from 'react';
import'./Footer.css'
import { FaFacebookF } from 'react-icons/fa';
import { FiInstagram } from 'react-icons/fi';
import{IoLogoTwitter} from 'react-icons/io';
import {AiOutlineLinkedin} from 'react-icons/ai';

const Footer = () => {
    return (
        <footer>
          <a href="" className='footer_logo'>Joyanti</a>
          <ul className='premalinks'>
            <li><a href="">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/experience">Experience</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/project">Project</a></li>
            <li><a href="/testimonial">Testimonial</a></li>
            <li><a href="/contact">Contact</a></li>

           
          </ul>


          <div className="footer_social">
            <a href="https://facebook.com"><FaFacebookF></FaFacebookF></a>
            <a href="https://instagram.com"><FiInstagram></FiInstagram></a>
            <a href="https://twiter.com"><IoLogoTwitter></IoLogoTwitter></a>
            <a href="https://linkedin.com"><AiOutlineLinkedin></AiOutlineLinkedin></a>

          </div>
          <div className="footer_copyright">
            <small>&copy, Joyanti chowdhury.All rights reserved 2023</small>
          </div>
        </footer>
    );
};

export default Footer;